module.exports = __webpack_public_path__ + "static/img/ww.f5f3976.png";


//////////////////
// WEBPACK FOOTER
// ./Public/Media/images/ww.png
// module id = Ktog
// module chunks = 14